module.exports = __webpack_public_path__ + "static/media/NULS-BUSD.edfc7736.svg";